import React, { useState, useEffect } from "react";

import { TableRow, TableCell } from "@material-ui/core";

import { stableSort, getComparator } from "App/Component/ui/datatable/utils";

import {
  TableWrapper,
  TableAction,
  ModalDeleteConfirm,
  TableCellDefault,
} from "App/Component/ui";

import { useFetch, useDatatables } from "App/hooks";
import {
  ModalForm,
  headCells,
  deleteMasterGolonganObatById,
  RESET_STATE_MASTER_GOLONGAN_OBAT,
  urlGet,
} from "./helpers";
import { STYLE_DEFAULT_MASTER, TYPE_INSTANCE4 } from "App/constants";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
} from "App/utils/helpers";
import {
  FilterColumns,
  PrepareDataExport,
} from "App/Component/layout/MasterData/helpers";

export default function MasterGolonganObat() {
  const classes = STYLE_DEFAULT_MASTER();
  const [rows, setRows] = useFetch(TYPE_INSTANCE4, urlGet, "data");
  const [showModalDeleteConfirm, setShowModalDeleteConfirm] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const [formData, setFormData] = useState(RESET_STATE_MASTER_GOLONGAN_OBAT);
  const {
    page,
    setQ,
    setPage,
    setRowsPerPage,
    data,
    order,
    orderBy,
    handleRequestSort,
    length,
    rowsPerPage,
  } = useDatatables({
    rows: rows,
    orderByDefault: "name",
    orderByRow: ["name"],
  });

  function clickAdd() {
    setFormData(RESET_STATE_MASTER_GOLONGAN_OBAT);
    setShowModal(!showModal);
  }

  function clickUpdate(row) {
    setFormData({
      id: row?.id,
      name: row?.name,
      remark: row?.remark,
    });

    setShowModal(true);
  }

  function clickDelete(row) {
    setFormData({
      ...formData,
      id: row?.id,
    });
    setShowModalDeleteConfirm(!showModalDeleteConfirm);
  }

  const setNewData = async () => {
    const newData = await fetchData(TYPE_INSTANCE4, urlGet, "data");
    setRows(newData);
  };

  useEffect(() => {
    (async () => {
      await setNewData();
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const deleteList = async () => {
    const res = await deleteMasterGolonganObatById(formData.id);
    if (res.state) {
      defaultToastSuccess(res.message);
      setNewData();
    } else {
      defaultToastError(res.message);
    }

    setShowModalDeleteConfirm(false);
  };

  const prepareHeaders = {
    id: "id",
    name: "nama",

    createdAt: "inserted_time:date",
    createdName: "inserted_by",
    updatedAt: "updated_time:date",
    updatedName: "updated_by",
  };
  const dataExport = PrepareDataExport(data, prepareHeaders);
  const headerExport = FilterColumns(dataExport);
  return (
    <div className={classes.root}>
      {showModal && (
        <ModalForm
          setNewData={setNewData}
          setShowModal={() => setShowModal(false)}
          formData={formData}
          setFormData={setFormData}
        />
      )}

      {showModalDeleteConfirm && (
        <ModalDeleteConfirm
          confirmHandle={() => deleteList()}
          setShowModalDeleteConfirm={() => setShowModalDeleteConfirm(false)}
        />
      )}

      <TableWrapper
        title='Daftar Golongan Obat Perbekalan Farmasi'
        setQ={setQ}
        clickAddButton={() => clickAdd()}
        withExportButton={true}
        allData={dataExport}
        headers={headerExport}
        order={order}
        orderBy={orderBy}
        handleRequestSort={handleRequestSort}
        length={length}
        rows={rows}
        headCells={headCells}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}>
        {stableSort(data, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row, index) => {
            return (
              <TableRow
                hover
                tabIndex={-1}
                key={index}
                style={{
                  backgroundColor: index % 2 === 0 ? "transparent" : "#fff",
                }}>
                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  {index + 1}
                </TableCell>

                <TableCell
                  component='th'
                  scope='row'
                  padding='none'
                  align='center'>
                  <TableAction
                    clickDelete={() => clickDelete(row)}
                    clickUpdate={() => clickUpdate(row)}
                  />
                </TableCell>

                <TableCell align='left'>{row?.name}</TableCell>
                <TableCell align='left'>{row?.remark}</TableCell>

                <TableCellDefault row={row} type='custom' />
              </TableRow>
            );
          })}
      </TableWrapper>
    </div>
  );
}
